import type { HTTPResponse, ProblemResponse } from "@/lib/http";
import type { UseMutationResult } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "sonner";

export const useNotifyMutationError = <T, U>(mutation: UseMutationResult<HTTPResponse<T>, ProblemResponse, U>) => {
	useEffect(() => {
		if (!mutation.error) {
			return;
		}

		toast.error("Uh oh!", {
			description: mutation.error.problem.description,
			position: "bottom-center"
		});
	}, [mutation.error]);
};
